import { Box } from "@mui/material";
import { createFileRoute, Outlet, useMatchRoute } from "@tanstack/react-router";

import { ListDetailHeader } from "@/features/ListsV2/components/ListDetailHeader";
import { ListIndexHeader } from "@/features/ListsV2/components/ListIndexHeader";
import theme from "@/theme";

export const Route = createFileRoute("/_auth/people/$siteId/lists")({
  component: () => {
    return <ListsRoute />;
  },
});

function ListsRouteHeader() {
  const matchRoute = useMatchRoute();

  const isDetailPage = matchRoute({
    from: "/people/$siteId/lists/$listId",
    fuzzy: true,
  });

  if (isDetailPage) {
    return <ListDetailHeader />;
  }

  return <ListIndexHeader />;
}

const ListsRoute = () => {
  return (
    <Box
      sx={{
        background: `${theme.palette.background["paper-elevation-1"]}`,
        width: "100%",
        height: "100%",
        flex: "1",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch",
          padding: `${theme.spacing(7)} ${theme.spacing(7)}`,
          minHeight: 130,
        }}
      >
        <ListsRouteHeader />
      </Box>
      <Outlet />
    </Box>
  );
};
